/* tslint:disable */
/* eslint-disable */
/**
 * Mclarens.OutlookAddin.Api.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MoneyModel } from './MoneyModel';
import {
    MoneyModelFromJSON,
    MoneyModelFromJSONTyped,
    MoneyModelToJSON,
} from './MoneyModel';

/**
 * 
 * @export
 * @interface ClaimFinancialSummary
 */
export interface ClaimFinancialSummary {
    /**
     * 
     * @type {string}
     * @memberof ClaimFinancialSummary
     */
    claimNumber: string;
    /**
     * 
     * @type {MoneyModel}
     * @memberof ClaimFinancialSummary
     */
    totalReserve: MoneyModel | null;
    /**
     * 
     * @type {MoneyModel}
     * @memberof ClaimFinancialSummary
     */
    outstandingAmount: MoneyModel | null;
}

/**
 * Check if a given object implements the ClaimFinancialSummary interface.
 */
export function instanceOfClaimFinancialSummary(value: object): value is ClaimFinancialSummary {
    if (!('claimNumber' in value) || value['claimNumber'] === undefined) return false;
    if (!('totalReserve' in value) || value['totalReserve'] === undefined) return false;
    if (!('outstandingAmount' in value) || value['outstandingAmount'] === undefined) return false;
    return true;
}

export function ClaimFinancialSummaryFromJSON(json: any): ClaimFinancialSummary {
    return ClaimFinancialSummaryFromJSONTyped(json, false);
}

export function ClaimFinancialSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimFinancialSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'claimNumber': json['claimNumber'],
        'totalReserve': MoneyModelFromJSON(json['totalReserve']),
        'outstandingAmount': MoneyModelFromJSON(json['outstandingAmount']),
    };
}

export function ClaimFinancialSummaryToJSON(value?: ClaimFinancialSummary | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'claimNumber': value['claimNumber'],
        'totalReserve': MoneyModelToJSON(value['totalReserve']),
        'outstandingAmount': MoneyModelToJSON(value['outstandingAmount']),
    };
}

